module.exports = __webpack_public_path__ + "539d3f95103bf90edc4d89267c2c49e3.svg";